import axios from 'axios';
import httpClient from '@/axios';






const authService = {
    
    user: null,
   async Login(formData){
    try {
        const {status, data} = await httpClient.post('/web/api/user/login',formData);
        console.log(status,data);
        const detailsArray =  JSON.stringify(data.details);
        console.log(detailsArray);
        //this.token = data.access_token;
       if(status === 200){
        this.setUser(data);
        const permissionsArray = data.permistion;
       
        localStorage.setItem('PERMISSIONS', JSON.stringify(permissionsArray));

        const detailsArray = data.details;
        localStorage.setItem('LANGUAGE', JSON.stringify(detailsArray));
        
   
        if(data.contractor_id==0){
          
            return {success: 1}; 
        }else if(data.contractor_id!=0){
            return {success: 2};
        }
         
       }
      } catch (error) {
        console.log(error.response);
        this.errorsf = error.response.data.errors.username
        this.errors2f = error.response.data.errors.password
        if( this.errorsf){
            this.errors = error.response.data.errors.username[0];
        }
        if( this.errors2f){
            this.errors2 = error.response.data.errors.password[0];
        }
        
        return {
            success: false,
            errors: this.errors,
            errors2: this.errors2,
            
            
        }
      }
    },

    
    setUser(data){
       
        localStorage.setItem('ACCESS_TOKEN', data.user.access_token);
        localStorage.setItem('USERNAME', data.user.username);
        localStorage.setItem('USERID', data.user.id);
        localStorage.setItem('SUPERADMIN', data.user.superadmin);
 
        const permissionsArray = data.permistion;
       localStorage.setItem('PERMISSIONS', JSON.stringify(permissionsArray));
        const detailsArray = data.details;
       localStorage.setItem('LANGUAGE', JSON.stringify(detailsArray));
     // localStorage.setItem('PERMISSIONS', permissionsArray);
      

        

      

// Now you can use the permissionsArray as a regular array
       
    },
    isLoggedIn(){
        return localStorage.getItem('ACCESS_TOKEN');
       
    },

    isUsername(){
        return localStorage.getItem('USERNAME');
    },
    isUserid(){
        return localStorage.getItem('USERID');
    },
    isSuperadmin(){
        return localStorage.getItem('SUPERADMIN');
    },
    isPermission(){
        return localStorage.getItem('PERMISSIONS');
    },
    isLanguage(){
        return localStorage.getItem('LANGUAGE');
    },

    
    
    
    Logout(){
        
       
        localStorage.removeItem('ACCESS_TOKEN');
        localStorage.removeItem('USERNAME');
        localStorage.removeItem('USERID');
        localStorage.removeItem('SUPERADMIN');
        localStorage.removeItem('PERMISSIONS');
        localStorage.removeItem('LANGUAGE');
        this.$router.push({name: 'LoginView'})
        
        
    }
};



export default authService;